<template>
  <div class="grid">
    <div class="col-12 lg:col-6 xl:col-3">
      <div class="card h-full mb-0">
        <div class="flex justify-content-between mb-3">
          <div>
            <span class="block text-500 font-medium mb-3">سفارشات</span>
            <div class="text-900 w-max font-medium text-xl">{{ statistics.reserve.inMonth }}</div>
          </div>
          <div class="flex align-items-center justify-content-center bg-cyan-100 border-round" style="width: 2.5rem; height: 2.5rem">
            <i class="pi pi-inbox text-cyan-500 text-xl"></i>
          </div>
        </div>
        <span class="text-500">مجموع: </span>
        <span class="text-green-500 font-medium">{{ statistics.reserve.total }}</span>
      </div>
    </div>
    <div class="col-12 lg:col-6 xl:col-3">
      <div class="card h-full mb-0">
        <div class="flex justify-content-between mb-3">
          <div>
            <span class="block text-500 font-medium mb-3">رزروها</span>
            <div class="text-900 w-max font-medium text-xl">{{ statistics.purchase.inMonth.toLocaleString("fa-IR") }} <small>(تومان)</small></div>
          </div>
          <div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width: 2.5rem; height: 2.5rem">
            <i class="pi pi-shopping-cart text-blue-500 text-xl"></i>
          </div>
        </div>
        <span class="text-500">مجموع: </span>
        <span class="text-green-500 font-medium">{{ statistics.purchase.total.toLocaleString("fa-IR") }} <small>(تومان)</small></span>
      </div>
    </div>
    <div class="col-12 lg:col-6 xl:col-3">
      <div class="card h-full mb-0">
        <div class="flex justify-content-between mb-3">
          <div>
            <span class="block text-500 font-medium mb-3">مشتریان</span>
            <div class="text-900 w-max font-medium text-xl">{{ statistics.feedback.inMonth }}</div>
          </div>
          <div class="flex align-items-center justify-content-center bg-orange-100 border-round" style="width: 2.5rem; height: 2.5rem">
            <i class="pi pi-users text-orange-500 text-xl"></i>
          </div>
        </div>
        <span class="text-500">مجموع: </span>
        <span class="text-green-500 font-medium">{{ statistics.feedback.total }} </span>
      </div>
    </div>
    <div class="col-12 lg:col-6 xl:col-3">
      <div class="card h-full mb-0">
        <div class="flex justify-content-between mb-3">
          <div>
            <span class="block text-500 font-medium mb-3">بازخوردها</span>
            <div class="text-900 w-max font-medium text-xl">{{ statistics.customer.inMonth }}</div>
          </div>
          <div class="flex align-items-center justify-content-center bg-purple-100 border-round" style="width: 2.5rem; height: 2.5rem">
            <i class="pi pi-comment text-purple-500 text-xl"></i>
          </div>
        </div>
        <span class="text-500">مجموع: </span>
        <span class="text-green-500 font-medium">{{ statistics.customer.total }}</span>
      </div>
    </div>

    <div class="col-12 xl:col-6">
      <div class="card">
        <h5>آخرین سفارشات</h5>
        <DataTable :value="recentOrders" responsiveLayout="scroll" class="mt-4">
          <Column field="placeName" headerStyle="width:14%; min-width:10rem;">
            <template #header>
              <small>نام اقامتگاه</small>
            </template>
            <template #body="slotProps">
              <small>{{ slotProps.data.placeName }}</small>
            </template>
          </Column>
          <Column field="userFullName" headerStyle="width:14%; min-width:10rem;">
            <template #header>
              <small>نام رزرو کننده</small>
            </template>
            <template #body="slotProps">
              <small>{{ slotProps.data.userFullName }}</small>
            </template>
          </Column>
          <Column field="date" headerStyle="width:14%; min-width:10rem;">
            <template #header>
              <small>تاریخ</small>
            </template>
            <template #body="slotProps">
              <small>{{ new Date(slotProps.data.date).toLocaleDateString("fa-IR") }}</small>
            </template>
          </Column>
          <Column field="cityName" headerStyle="width:14%; min-width:10rem;">
            <template #header>
              <small>نام شهر</small>
            </template>
            <template #body="slotProps">
              <small>{{ slotProps.data.cityName }}</small>
            </template>
          </Column>
          <Column field="price" headerStyle="width:14%; min-width:10rem;">
            <template #header>
              <small>مبلغ</small>
            </template>
            <template #body="slotProps">
              <small>{{ slotProps.data.price.toLocaleString("fa-IR") }} تومان</small>
            </template>
          </Column>
        </DataTable>
      </div>
      <!-- <div class="card">
			<div class="flex justify-content-between align-items-center mb-5">
				<h5>Best Selling Products</h5>
				<div>
					<Button icon="pi pi-ellipsis-v" class="p-button-text p-button-plain p-button-rounded" @click="$refs.menu2.toggle($event)"></Button>
					<Menu ref="menu2" :popup="true" :model="items"></Menu>
				</div>
			</div>
			<ul class="list-none p-0 m-0">
				<li class="flex flex-column md:flex-row md:align-items-center md:justify-content-between mb-4">
					<div>
						<span class="text-900 font-medium mr-2 mb-1 md:mb-0">Space T-Shirt</span>
						<div class="mt-1 text-600">Clothing</div>
					</div>
					<div class="mt-2 md:mt-0 flex align-items-center" dir="rtl">
						<div class="surface-300 border-round flex-row-reverse overflow-hidden dir-rtl w-10rem lg:w-6rem" style="height:8px">
							<div class="bg-orange-500 h-full" style="width:80%"></div>
						</div>
						<span class="text-orange-500 mr-3 font-medium">%50</span>
					</div>
				</li>
			</ul>
		</div> -->
    </div>
    <div class="col-12 xl:col-6">
      <div v-if="!!lineData.labels.length" class="card">
        <h5>نمودار</h5>
        <Chart type="line" :data="lineData" :options="lineOptions" />
      </div>
      <div v-if="!!recentFeedbacks.length" class="card">
        <div class="flex align-items-center justify-content-between mb-4">
          <h5>آخرین نظرات</h5>
          <!-- <div>
					<Button icon="pi pi-ellipsis-v" class="p-button-text p-button-plain p-button-rounded" @click="$refs.menu1.toggle($event)"></Button>
					<Menu ref="menu1" :popup="true" :model="items"></Menu>
				</div> -->
        </div>
        <div v-for="(item, index) in recentFeedbacks" :key="`LastFeedbacks-${index}`" class="border-bottom">
          <div class="flex align-items-center justify-content-between">
            <div>
              <span class="text-600 font-medium">ارسال کننده: </span>
              <span class="text-600 font-medium">{{ item.fullName || "نا شناس" }}</span>
            </div>
            <span class="text-600 font-medium">({{ new Date(item.createdAt).toLocaleDateString("fa-IR") }})</span>
          </div>
          <li class="flex align-items-center py-2">
            <div class="w-3rem h-3rem flex align-items-center justify-content-center bg-orange-100 border-circle ml-3 flex-shrink-0">
              <i class="pi pi-comment text-xl text-orange-500"></i>
            </div>
            <span class="text-700 line-height-3">{{ item.message }}</span>
          </li>
          <Divider type="dashed" />
          <!-- <ul class="p-0 mx-0 mt-0 mb-4 list-none">
					<li class="flex align-items-center py-2 border-bottom-1 surface-border">
						<div class="w-3rem h-3rem flex align-items-center justify-content-center bg-blue-100 border-circle ml-3 flex-shrink-0">
							<i class="pi pi-dollar text-xl text-blue-500"></i>
						</div>
						<span class="text-900 line-height-3">Richard Jones
							<span class="text-700">has purchased a blue t-shirt for <span class="text-blue-500">79$</span></span>
						</span>
					</li> -->
          <!-- </ul> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/AppEventBus";
import ProductService from "@/service/ProductService";
import { conditionalExpression } from "@babel/types";

export default {
  data() {
    return {
      products: null,
      lineData: {
        // labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        labels: [],
        datasets: [
          {
            label: "درآمد",
            data: [],
            fill: false,
            backgroundColor: "#2f4860",
            borderColor: "#2f4860",
            tension: 0.4,
          },
          // {
          // 	label: 'Sales',
          // 	data: [28, 48, 40, 19, 86, 27, 90],
          // 	fill: false,
          // 	backgroundColor: '#00bb7e',
          // 	borderColor: '#00bb7e',
          // 	tension: 0.4
          // }
        ],
      },
      items: [
        { label: "Add New", icon: "pi pi-fw pi-plus" },
        { label: "Remove", icon: "pi pi-fw pi-minus" },
      ],
      lineOptions: null,
      statistics: {
        reserve: {
          inMonth: 0,
          total: 0,
        },
        purchase: {
          inMonth: 0,
          total: 0,
        },
        feedback: {
          inMonth: 0,
          total: 0,
        },
        customer: {
          inMonth: 0,
          total: 0,
        },
      },
      recentOrders: [],
      recentFeedbacks: [],
    };
  },
  productService: null,
  themeChangeListener: null,
  mounted() {
    this.productService.getProductsSmall().then((data) => (this.products = data));

    this.themeChangeListener = (event) => {
      if (event.dark) this.applyDarkTheme();
      else this.applyLightTheme();
    };
    EventBus.on("change-theme", this.themeChangeListener);

    if (this.isDarkTheme()) {
      this.applyDarkTheme();
    } else {
      this.applyLightTheme();
    }
    this.getStatistics();
    this.getLastOrders();
    this.getLastFeedbacks();
    this.getChartData();
  },
  beforeUnmount() {
    EventBus.off("change-theme", this.themeChangeListener);
  },
  created() {
    this.productService = new ProductService();
  },
  methods: {
    formatCurrency(value) {
      return value.toLocaleString("en-US", { style: "currency", currency: "USD" });
    },
    isDarkTheme() {
      return this.$appState.darkTheme === true;
    },
    applyLightTheme() {
      this.lineOptions = {
        plugins: {
          legend: {
            labels: {
              color: "#495057",
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: "#495057",
            },
            grid: {
              color: "#ebedef",
            },
          },
          y: {
            ticks: {
              color: "#495057",
            },
            grid: {
              color: "#ebedef",
            },
          },
        },
      };
    },
    applyDarkTheme() {
      this.lineOptions = {
        plugins: {
          legend: {
            labels: {
              color: "#ebedef",
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: "#ebedef",
            },
            grid: {
              color: "rgba(160, 167, 181, .3)",
            },
          },
          y: {
            ticks: {
              color: "#ebedef",
            },
            grid: {
              color: "rgba(160, 167, 181, .3)",
            },
          },
        },
      };
    },
    async getStatistics() {
      const { status, data } = await this.axios({ method: "get", url: "dashboard/statistics" });
      if (status === 200) {
        this.statistics = { ...data };
      }
    },
    async getLastOrders() {
      const { status, data } = await this.axios({ method: "get", url: "dashboard/LatestReserves?PageIndex=1&PageSize=5" });
      if (status === 200) {
        this.recentOrders = [...data.data];
      }
    },
    async getLastFeedbacks() {
      const { status, data } = await this.axios({ method: "get", url: "dashboard/lastFeedback" });
      if (status === 200) {
        this.recentFeedbacks = [...data];
      }
    },
    async getChartData() {
      const { status, data } = await this.axios({ method: "get", url: "dashboard/SalesByDayList" });
      if (status === 200) {
        let priceDataContainer = [];
        let dateDataContainer = [];
        for (let item of data) {
          priceDataContainer.push(item.price);
          dateDataContainer.push(new Date(item.date).toLocaleDateString("fa-IR"));
        }
        this.lineData.datasets[0].data = priceDataContainer;
        this.lineData.labels = dateDataContainer;
      }
    },
  },
};
</script>
